import type { PropsWithChildren } from 'react'
import { ToastContainer } from 'react-toastify'
import { DesignSystemProvider } from '@/shared/provider/design-system-provider/design-system-provider.tsx'
import { I18nProvider } from '@/shared/provider/i18n-provider/i18n-provider.tsx'
import {
	QueryProvider,
	type QueryProviderProps,
} from '@/shared/provider/query-provider/query-provider.tsx'
import { RouterProvider } from '@/shared/provider/router-provider/router-provider.tsx'
import { ScrollProvider } from '@/shared/provider/scroll-context/scroll-context.tsx'
import { ThemeProvider } from '@/shared/provider/theme-provider/theme-provider.tsx'

interface AggregateProviderProps {
	queryProviderProps: QueryProviderProps
}

export function AggregateProvider({
	queryProviderProps,
	children,
}: Readonly<PropsWithChildren<AggregateProviderProps>>) {
	return (
		<DesignSystemProvider>
			<I18nProvider>
				<QueryProvider {...queryProviderProps}>
					<ScrollProvider>
						<ThemeProvider>
							{children}
							<RouterProvider />
							<ToastContainer
								autoClose={5000}
								closeOnClick={true}
								draggable={true}
								hideProgressBar={false}
								newestOnTop={true}
								pauseOnFocusLoss={true}
								pauseOnHover={true}
								position='bottom-right'
								rtl={false}
							/>
						</ThemeProvider>
					</ScrollProvider>
				</QueryProvider>
			</I18nProvider>
		</DesignSystemProvider>
	)
}
